import { createContext, type ReactNode } from 'react';

export interface FeatureFlagsState {
  /** Controls "already a customer" section in the Check Availability pop-up. Default false for this release. */
  enableExistingCustomerFlow: boolean;
}

const envExistingCustomerFlow = import.meta.env.VITE_ENABLE_EXISTING_CUSTOMER_FLOW === 'true';

export const FeatureFlagContext = createContext<FeatureFlagsState | null>(null);

interface FeatureFlagProviderProps {
  enableExistingCustomerFlow?: boolean;
  children: ReactNode;
}

export const FeatureFlagProvider = ({
  enableExistingCustomerFlow = envExistingCustomerFlow,
  children,
}: FeatureFlagProviderProps) => (
  <FeatureFlagContext.Provider value={{ enableExistingCustomerFlow }}>{children}</FeatureFlagContext.Provider>
);
